import { ERROR_MESSAGE_FOR_PAGE_VALIDATION } from '@common/middleware/errorMessages';
import { validateProjectDraftFailure } from '@console/actions/actions';
import type {
  AppThunkAction,
  AppThunkDispatch
} from '@console/actions/thunkType';
import { validateGifteeBoxDeliveryConfigThunk } from '@console/actions/thunks/validateProjectDraft/validateGiftConfig/validateDeliveryConfig';
import { getActiveStep } from '@console/common/getActiveStep';
import GifteeBoxDeliveryConfig from '@console/components/common/deliveryConfig/GifteeBoxDeliveryConfig';
import type { AppState } from '@console/reducers';
import {
  getSelectedProjectDraftSelectedGiftConfig,
  isApiSolutionSystemSelected,
  isBulkSolutionSystemSelected,
  isGcpSolutionSystemSelected
} from '@console/selectors/getSelectedProjectDraftForDisplay';
import { getSelectedGifteeBoxTemplate } from '@console/selectors/projectJson/giftConfigs';
import { connect } from 'react-redux';
import type { NavigateFunction } from 'react-router';

const handleStepNextFromParent =
  (navigate: NavigateFunction): AppThunkAction<void> =>
  dispatch =>
    dispatch(validateGifteeBoxDeliveryConfigThunk())
      .then(() => {
        const { parentStep } = getActiveStep();

        navigate(
          `${location.pathname}?parentStep=${parentStep}&childStep=${0}`
        );
      })
      .catch(() => {
        dispatch(
          validateProjectDraftFailure(ERROR_MESSAGE_FOR_PAGE_VALIDATION)
        );
      });

const mapStateToProps = (state: AppState) => ({
  isBulkSolutionSystemSelected: isBulkSolutionSystemSelected(state),
  isApiSolutionSystemSelected: isApiSolutionSystemSelected(state),
  isGcpSolutionSystemSelected: isGcpSolutionSystemSelected(state),
  giftConfig: getSelectedProjectDraftSelectedGiftConfig(state),
  selectedGifteeBoxTemplate: getSelectedGifteeBoxTemplate(state)
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  handleStepNextFromParent: (navigate: NavigateFunction) =>
    dispatch(handleStepNextFromParent(navigate))
});

export type GifteeBoxDeliveryConfigPropsMappedFromState = ReturnType<
  typeof mapStateToProps
>;
export type GifteeBoxDeliveryConfigPropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GifteeBoxDeliveryConfig);
